module.exports = __webpack_public_path__ + "static/media/compressed-image.cba5aeb4.jpg";